<!-- TikTok Message -->
<ng-container *ngIf="pages?.[0]?.platform?.toLowerCase().includes('tiktok'); else notTiktokAlerts">
  <div class="col-span-12 bg-white rounded-2xl border border-dashed border-gray-200 bg-gray-50/70 p-8">
    <div class="flex h-[360px] w-full flex-col items-center justify-center gap-4 text-center">
      <div>
        <p class="mb-1 text-sm font-semibold text-gray-500">
          TikTok analytics are not available yet.
        </p>
        <p class="text-xs text-gray-400">
          We're working on bringing you TikTok insights soon.
        </p>
      </div>
    </div>
  </div>
</ng-container>

<!-- Non-TikTok Content -->
<ng-template #notTiktokAlerts>
  <div class="grid grid-cols-12 gap-6">

    <!-- POST ALERTS CARD -->
    <div class="col-span-12 bg-white">

    <!-- PAGINATOR -->
    <div class="border-t border-gray-100">
      <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageIndex]="currentPage - 1"
        [pageSizeOptions]="[pageSize]" showFirstLastButtons (page)="onPageChange($event)"
        [disabled]="isLoading || totalItems <= pageSize" class="mb-2">
      </mat-paginator>
    </div>

    <!-- LOADING -->
    <div *ngIf="isLoading" class="flex flex-col justify-center items-center text-center py-10 text-gray-400 animate-pulse">
      <div class="animate-spin h-8 w-8 border-4 border-gray-300 border-t-gray-700 rounded-full mb-2"></div>
      Loading Alerts
    </div>

    <!-- NO DATA -->
    <div *ngIf="!isLoading && postAlerts.length === 0" class="text-center py-10 text-gray-400 italic">
      No alerts found.
    </div>

    <!-- TABLE GRID -->
    <div *ngIf="!isLoading && postAlerts.length > 0 && !isMobile" class="border border-gray-100 rounded-lg overflow-hidden">

      <!-- HEADER -->
      <div
        class="grid grid-cols-[1fr_10rem_14rem_8rem_8rem] bg-gray-50 border-b border-gray-200 text-gray-700 font-medium text-sm">
        <div class="py-3 px-4">Website</div>
        <div class="py-3 px-4">Platform</div>
        <div class="py-3 px-4">Alert</div>
        <div class="py-3 px-4 text-center">Period</div>
        <div class="py-3 px-4 text-right">Action</div>
      </div>


      <!-- BODY -->
      <div class="divide-y divide-gray-100">
        <div *ngFor="let alert of postAlerts; let i = index"
          class="grid grid-cols-[1fr_10rem_14rem_8rem_8rem] items-center hover:bg-gray-50 transition-colors text-sm">

          <!-- WEBSITE -->
          <div class="py-3 px-4">
            <div class="grid grid-cols-[auto_1fr] items-center gap-3">
              <img [src]="alert.thumbnail" (error)="onImageError($event)"
                class="w-10 h-10 rounded-full border border-gray-300 object-cover me-2" />

              <!-- Site info -->
              <div class="min-w-0">
                <p class="font-medium text-gray-800 truncate">
                  {{ alert.domain }}
                </p>
                <p class="text-xs text-gray-500">
                  {{ alert.datetime }}
                </p>
              </div>
            </div>
          </div>

          <!-- PLATFORM -->
          <div class="py-3 px-4 text-gray-700">
            <span class="capitalize">{{ alert.platform }}</span>
          </div>

          <!-- ALERT -->
      <div class="py-3 px-4">
      <div class="grid gap-1">

        <!-- Metric -->
        <p class="text-[13px] font-semibold text-gray-800 capitalize">
          {{ alert.title }}
        </p>

        <!-- Main Alert Line -->
        <div class="flex items-center gap-1 text-[13px]">

          <!-- Arrow -->
          <span
            *ngIf="alert.alert_type === 'success'"
            class="text-green-600 font-semibold"
          >
            ▲
          </span>

          <span
            *ngIf="alert.alert_type === 'warning'"
            class="text-yellow-500 font-semibold"
          >
            ▼
          </span>

          <span
            *ngIf="alert.alert_type === 'danger' || alert.alert_type === 'error'"
            class="text-red-600 font-semibold"
          >
            ▼
          </span>

          <span
            *ngIf="!['success','warning','danger','error'].includes(alert.alert_type)"
            class="text-blue-500 font-semibold"
          >
            ►
          </span>

          <!-- Text -->
          <span
            [class.text-green-600]="alert.alert_type === 'success'"
            [class.text-yellow-500]="alert.alert_type === 'warning'"
            [class.text-red-600]="alert.alert_type === 'danger' || alert.alert_type === 'error'"
            [class.text-blue-500]="!['success','warning','danger','error'].includes(alert.alert_type)"
          >
            {{ alert.mainText }}
          </span>

        </div>

        <!-- Delta -->
        <p class="text-xs text-gray-500">
          {{ alert.delta }}
          <span *ngIf="alert.oldValue && alert.newValue">
            ({{ alert.oldValue }} → {{ alert.newValue }})
          </span>
        </p>

      </div>
    </div>



          <!-- PERIOD -->
          <div class="py-3 px-4 text-center text-gray-700 font-medium">
            {{ alert.period }}
          </div>

          <!-- ACTIONS -->
          <div class="py-3 px-4 text-right">
            <button
              class="cursor-pointer px-3 py-1.5 text-xs border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100 active:bg-gray-200 transition"
              (click)="dismissAlert(alert.id)">
              Dismiss
            </button>
          </div>
        </div>
      </div>

    </div>


    <div *ngIf="!isLoading && postAlerts.length > 0 && isMobile" class="flex flex-col gap-3">
      <div *ngFor="let alert of postAlerts" class="border border-gray-100 rounded-lg p-3 flex flex-col gap-1">

        <div class="flex items-center gap-3">
          <img [src]="alert.thumbnail" (error)="onImageError($event)" class="w-10 h-10 rounded-full border border-gray-300 object-cover" />
          <div>
            <p class="font-medium text-gray-800 text-sm">{{ alert.domain }}</p>
            <p class="text-xs text-gray-400">{{ alert.datetime }}</p>
          </div>
          <span class="ml-auto text-xs text-gray-500 font-medium">{{ alert.period }}</span>
        </div>

        <p class="text-[13px] font-semibold text-gray-800 capitalize">{{ alert.title }}</p>

        <div class="flex items-center gap-1 text-[13px]">
          <span [class.text-green-600]="alert.alert_type === 'success'"
                [class.text-yellow-500]="alert.alert_type === 'warning'"
                [class.text-red-600]="alert.alert_type === 'danger' || alert.alert_type === 'error'"
                [class.text-blue-500]="!['success','warning','danger','error'].includes(alert.alert_type)">
            {{ alert.mainText }}
          </span>
        </div>

        <p class="text-xs text-gray-500">{{ alert.delta }} <span *ngIf="alert.oldValue && alert.newValue">({{ alert.oldValue }} → {{ alert.newValue }})</span></p>

        <button class="self-end mt-1 px-3 py-1.5 text-xs border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100 transition" (click)="dismissAlert(alert.id)">
          Dismiss
        </button>
      </div>
    </div>

    <!-- PAGINATOR -->
    <div class="border-t border-gray-100">
      <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageIndex]="currentPage - 1"
        [pageSizeOptions]="[pageSize]" showFirstLastButtons (page)="onPageChange($event)"
        [disabled]="isLoading || totalItems <= pageSize" class="mt-2">
      </mat-paginator>
    </div>

    </div>

  </div>
</ng-template>
